module.exports = {
  content: [
    './src/app/**/*.{js,jsx,ts,tsx}',
    './src/pages/**/*.{js,jsx,ts,tsx}',
    './src/components/**/*.{js,jsx,ts,tsx}',
    './src/templates/**/*.{js,jsx,ts,tsx}',
    './src/helpers/*.{js,jsx,ts,tsx}',
    './node_modules/@elastic/react-search-ui-views/lib/**/*.{js,jsx,ts,tsx}',
    './node_modules/@elastic/react-search-ui-views/lib/esm/**/*.{js,jsx,ts,tsx}',
  ],
  safelist: [
    'animation-delay-0',
    'animation-delay-1',
    'animation-delay-2',
    'animation-delay-3',
    'animation-delay-4',
    'animation-delay-5',
    'animation-delay-6',
    'animation-delay-7',
    'animation-delay-8',
    'animation-delay-9',
    'animation-delay-10',
    'animation-delay-11',
    'animation-delay-12',
    'border-brand-grey-2',
    'border-brand-green-2',
    'border-brand-red-2',
    'border-brand-blue-2',
    'border-brand-yellow-1',
    'border-brand-yellow-2',
  ],
  theme: {
    screens: {
      xs: '360px',
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1440px',
    },
    container: {
      center: true,
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      'brand-yellow': {
        1: '#FFDB00',
        2: '#FDC300',
        3: '#EF9617',
      },
      'brand-blue': {
        1: '#B0D7EC',
        2: '#5488C7',
        3: '#0058A3',
        4: '#007CC1',
        5: '#4D87C8',
      },
      'brand-green': {
        1: '#C0D9CA',
        2: '#8EBDA7',
        3: '#05676A',
        4: '#96C1A7',
      },
      'brand-red': {
        1: '#F4A698',
        2: '#EF776E',
        3: '#5D130E',
      },
      'brand-grey': {
        1: '#EAE3DA',
        2: '#D7CFC6',
        3: '#767571',
        4: '#474747',
      },
      'brand-white': '#FFFFFF',
      'accent-primary': {
        normal: '#FFDB00',
        dark: '#FDC300',
      },
      'accent-secondary': {
        blue: '#B0D7EC',
        green: '#C0D9CA',
        red: '#F4A698',
      },
      'neutral-grey': {
        100: '#EAE3DA',
        200: '#D7CFC6',
        300: '#ADAAA3',
        400: '#767571',
        700: '#474747',
        900: '#333333',
      },
      semantic: {
        negative: '#CC0511',
        caution: '#EF9617',
        positive: '#00A366',
        info: '#0058A3',
      },
      loyalty: {
        good: '#FDC300',
        close: '#8EBDA7',
        best: '#EF776E',
      },
      background: {
        primary: '#FFFFFF',
        'primary-light': '#F7F4EF',
        secondary: '#EAE3DA',
      },
      text: {
        default: '#474747',
        light: '#767571',
        'inverse-dark': '#EAE3DA',
        inverse: '#FFFFFF',
        accent: '#FFDB00',
        'sticker-yellow': '#EF9617',
        'sticker-red': '#5D130E',
        'sticker-green': '#05676A',
        'sticker-blue': '#0058A3',
      },
      icon: {
        default: '#474747',
        dark: '#767571',
        light: '#D7CFC6',
        inverse: '#FFFFFF',
        'accent-light': '#FFDB00',
        accent: '#FDC300',
        favourite: '#EF776E',
      },
      disabled: {
        dark: '#ADAAA3',
        light: '#D7CFC6',
      },
      transparency: {
        backdrop: 'rgba(71, 71, 71, 0.6) ',
        'overlay-solid': 'rgba(71, 71, 71, 0.4)',
        'gradient-from': 'rgba(71, 71, 71, 0)',
        'gradient-to': 'rgba(71, 71, 71, 0.68)',
        'stroke-grey': 'rgba(215, 207, 198, 0.5)',
        'stroke-blue': 'rgba(84, 136, 199, 0.5)',
        'stroke-green': 'rgba(142, 189, 167, 0.5)',
        'stroke-red': 'rgba(239, 119, 110, 0.5)',
      },
    },
    fontSize: {
      // Names refer to Ingka names in Figma https://www.figma.com/file/qaA8kSSeGZvO0sYrH0hn3H/INGKA-Centres-Foundations?node-id=17234%3A13
      headingxxl: ['2.5rem', { lineHeight: '1.1', fontWeight: 'bold' }],
      headingxl: ['2.25rem', { lineHeight: '1.1111', fontWeight: 'bold' }],
      headingl: ['1.75rem', { lineHeight: '1.1428', fontWeight: 'bold' }],
      headingm: ['1.5rem', { lineHeight: '1.1667', fontWeight: 'bold' }],
      headings: ['1rem', { lineHeight: '1.25', fontWeight: 'bold' }],
      headingxs: ['.875rem', { lineHeight: '1.2857', fontWeight: 'bold' }],
      headingxxs: ['.75rem', { lineHeight: '1.2857', fontWeight: 'bold' }],
      bodyxl: ['1.25rem', { lineHeight: '1.5' }],
      bodyl: ['1rem', { lineHeight: '1.5' }],
      bodymheavy: ['0.875rem', { lineHeight: '1.5', fontWeight: 'bold' }],
      bodym: ['0.875rem', { lineHeight: '1.5714' }],
      bodys: ['0.75rem', { lineHeight: '1.5' }],
      bodyxs: ['0.625rem', { lineHeight: '1.6' }],
      buttonlabell: ['0.875rem', { lineHeight: '1', fontWeight: 'bold' }],
      buttonlabelm: ['0.75rem', { lineHeight: '1', fontWeight: 'bold' }],
      buttonlabels: ['0.75rem', { lineHeight: '1' }],
      buttonlabelxs: ['0.625rem', { lineHeight: '1', fontWeight: 'bold' }],
    },
    fontFamily: {
      sans: [
        'Noto',
        'NotoCn',
        '"Noto Sans"',
        'ui-sans-serif',
        'system-ui',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ],
      title: ['Lively', 'Noto', 'NotoCn', 'san-serif'],
    },
    borderRadius: {
      none: '0',
      sm: '0.25rem',
      md: '0.5rem',
      lg: '1rem',
      xl: '1.25rem',
      xxl: '2.5rem',
      full: '9999px',
    },
    boxShadow: {
      default: '0px 0px 10px rgba(118, 117, 113, 0.3)',
      'down-right': '0px 2px 4px rgba(0, 0, 0, 0.15)',
    },
    animationDelay: {
      0: '0ms',
      1: '100ms',
      2: '200ms',
      3: '300ms',
      4: '400ms',
      5: '500ms',
      6: '600ms',
      7: '700ms',
      8: '800ms',
      9: '900ms',
      10: '950ms',
      11: '1000ms',
      12: '1050ms',
    },
    extend: {
      spacing: {
        1.25: '0.3125rem',
        3.75: '0.9375rem',
        7.5: '1.875rem',
        10.5: '2.625rem',
        15: '3.75rem',
        21: '5.25rem',
        22: '5.5rem',
        26: '6.5rem',
        27: '6.75rem',
        28: '7.75rem',
        46: '11.5rem',
        57: '14.25rem',
        68: '17rem',
      },
      textUnderlineOffset: {
        6: '6px',
      },
      aspectRatio: {
        '0.65/1': '0.65 / 1',
        '0.75/1': '0.75 / 1',
        '0.65/1': '0.65 / 1',
        '1/0.7': '1 / 0.7',
        '1.5/1': '1.5 / 1',
        '8/9': '8 / 9',
      },
      outlineOffset: {
        3: '0.1875rem',
      },
      outlineWidth: {
        3: '3px',
      },
      borderRadius: {
        card: '40px',
        'card-mobile': '20px',
        'card-receipt': '24px',
      },
      borderWidth: {
        3: '3px',
      },
      animation: {
        fadeIn: 'fadeIn 0.2s ease-in-out forwards',
        fadeInDown: 'fadeInDown 0.2s ease-in-out',
        fadeOutDown: 'fadeOutDown 0.4s ease-in-out forwards',
        fadeInUp: 'fadeInUp 0.2s ease-in-out',
        fadeInRight: 'fadeInRight 1s ease-out',
        listAnimation: 'listAnimation 500ms cubic-bezier(.47,1.64,.41,1)',
        tileAnimation: 'tileAnimation 500ms cubic-bezier(.47,1.64,.41,1.2)',
        tileTextAnimation:
          'tileTextAnimation 350ms cubic-bezier(.47,1.64,.41,1.2) 245ms forwards',
        wave: 'wave 2s linear infinite',
      },
      keyframes: {
        fadeIn: {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
        fadeInDown: {
          '0%': { opacity: 0, transform: 'translateY(-40px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
        fadeOutDown: {
          '0%': { opacity: 1, transform: 'translateY(0)' },
          '100%': { opacity: 0, transform: 'translateY(60px)' },
        },
        fadeInUp: {
          '0%': { opacity: 0, transform: 'translateY(40px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
        fadeInRight: {
          '0%': { opacity: 1, transform: 'translateX(100%)' },
          '100%': { opacity: 1, transform: 'translateX(0)' },
        },
        listAnimation: {
          '0%': { transform: 'scale(0.5)' },
          '50%': { transform: 'scale(1.02)' },
          '100%': { transform: 'scale(1)' },
        },
        tileAnimation: {
          '0%': { opacity: 0, transform: 'scale(0.9)' },
          '50%': { transform: 'scale(1.03)' },
          '100%': { opacity: 100, transform: 'scale(1)' },
        },
        tileTextAnimation: {
          '0%': { left: '50px', opacity: 0 },
          '100%': { left: '0px', opacity: 1 },
        },
        wave: {
          '0%': { backgroundPosition: '200% 0' },
          '100%': { backgroundPosition: '-200% 0' },
        },
      },
      backgroundImage: {
        dynamicStrokeGreen: 'url("/dynamic-stroke/green.svg")',
        dynamicStrokeRed: 'url("/dynamic-stroke/red.svg")',
        dynamicStrokeBlue: 'url("/dynamic-stroke/blue.svg")',
        dynamicStrokeGrey: 'url("/dynamic-stroke/grey.svg")',
        dynamicStrokeGreyDark: 'url("/dynamic-stroke/grey-dark.svg")',
        dynamicStrokeLargeGrey: 'url("/dynamic-stroke/large-grey.svg")',
        dynamicStrokeYellow: 'url("/dynamic-stroke/yellow.svg")',
        searchCancelIcon: 'url("/search/close-normal.svg")',
        dynamicStroke4: 'url("/dynamic-stroke/dynamic-stroke-4.svg")',
        // smallDynamicStrokeCountdownTimer:
        //   'url("../images/icons/smallDynamicstrokeCountdown.svg")',
        // largeDynamicStrokeCountdownTimer:
        //   'url("../images/icons/largeDynamicstrokeCountdown.svg")',
        // mobileDynamicStrokeCountdownTimer:
        //   'url("../images/icons/mobileDynamicstrokeCountdown.svg")',
      },
      minHeight: {
        40: '10rem',
      },
    },
  },
  plugins: [
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    require('tailwind-scrollbar-hide'),
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    require('tailwindcss-animation-delay'),
  ],
};
